export default __webpack_public_path__ + "static/transport3-img-f3a753b318777c9f6c9ff2d7575d1dea.jpg";